import { TranslationObject } from '../../i18n/translation';

const namespace = 'addpracticeplaceagreement';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Ny samarbeidsavtale',
    en: 'New cooperation agreement',
  },
  titleViewEdit: {
    id: `${namespace}.titleViewEdit`,
    nb: 'Samarbeidsavtale { avtalenavn }',
    en: 'Cooperation agreement { avtalenavn }',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her finner du skjema for opprettelse av samarbeidsavtaler',
    en: 'Here you will find a form to create cooperation agreement',
  },
  subtitleViewEdit: {
    id: `${namespace}.subtitleViewEdit`,
    nb: 'Her finner du informasjon om samarbeidsavtalen.',
    en: 'Here you will find information about the cooperation agreement.',
  },
  avtaletitle: {
    id: `${namespace}.avtaletitle`,
    nb: 'Samarbeidsavtale for praksis',
    en: 'Cooperation agreement for practice',
  },
  avtalesubtitle: {
    id: `${namespace}.avtalesubtitle`,
    nb: 'Beskriv hva samarbeidsavtalen handler om ved å gi den et navn. Avtalen må ha en startdato, men sluttdato er valgfritt. Dersom sluttdato ikke settes, vil avtalen løpe til den blir sagt opp. Brukeren som lager førsteutkastet til avtalen regnes automatisk som ansvarlig.',
    en: 'Describe the contents of the cooperation agreement by naming it. The agreement must have a start date, but an expiration date is optional. If an expiration date is not specified, the agreement will run until cancellation. The user that generates the first draft, will automatically be considered the responsible party.',
  },
  avtalesubtitleView: {
    id: `${namespace}.avtalesubtitleView`,
    nb: 'Overordnet informasjon om samarbeidsavtalen.',
    en: 'General information about the cooperation agreement.',
  },
  studiestedavdeling: {
    id: `${namespace}.studiestedavdeling`,
    nb: 'Velg et studiested hvor avtalen skal gjelde',
    en: 'Choose a place of study where the agreement will apply',
  },
  praksisstedname: {
    id: `${namespace}.praksisstedname`,
    nb: 'Velg et avtalested',
    en: 'Choose an appointment location',
  },
  praksistyper: {
    id: `${namespace}.praksistyper`,
    nb: 'Velg en eller flere praksistyper',
    en: 'Choose one or more practice types',
  },
  praksisstederomfattetavtale: {
    id: `${namespace}.praksisstederomfattetavtale`,
    nb: 'Velg en eller flere steder som inngår i avtalen',
    en: 'Choose one or more place that will be included in the agreement',
  },
  praksisaktivitetstart: {
    id: `${namespace}.praksisaktivitetstart`,
    nb: 'Avtalestart',
    en: 'Start date',
  },
  praksisaktivitetslutt: {
    id: `${namespace}.praksisaktivitetslutt`,
    nb: 'Utløpsdato',
    en: 'Expire date',
  },
  sendAvtale: {
    id: `${namespace}.sendAvtale`,
    nb: 'Send avtale',
    en: 'Send Agreement',
  },
  orgnr: {
    id: `${namespace}.orgnr`,
    nb: 'Søk på org.nummer til stedet avtalen gjelder',
    en: 'Search on org.number for the agreement',
  },
  invalidOrgnr: {
    id: `${namespace}.invalidOrgnr`,
    nb: 'Ugyldig organisasjonsnummer!',
    en: 'Invalid organisation number!',
  },
  ukjentOrgnr: {
    id: `${namespace}.ukjentOrgnr`,
    nb: 'Det eksisterer ingen praksissteder med dette organisasjonsnummeret i Arbeidslivsportalen',
    en: 'No practice place with this organisation number exists in Arbeidslivsportalen',
  },
  godtaOmfattetAvtale: {
    id: `${namespace}.godtaOmfattetAvtale`,
    nb: 'Jeg ønsker å legge til steder som skal inngå i avtalen som egne bestillingspunkt av praksisplasser',
    en: 'I wish to add additional places that will be a part of the agreement as their own order root for practice places',
  },
  agreementPostSuccess: {
    id: `${namespace}.agreementPostSuccess`,
    nb: 'Lagret praksisavtalen i FS',
    en: 'Saved practice agreement in FS',
  },
  missingRequiredFields: {
    id: `${namespace}.missingRequiredFields`,
    nb: 'Mangler påkrevde felter for å sende inn skjema!',
    en: 'Missing required fields for submitting the form!',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  cancelView: {
    id: `${namespace}.cancelView`,
    nb: 'Til avtaleliste',
    en: 'To list of agreements',
  },
  studiested: {
    id: `${namespace}.studiested`,
    nb: 'Studiested',
    en: 'Faculty',
  },
  studiestedSubtitle: {
    id: `${namespace}.studiestedSubtitle`,
    nb: 'Opplysninger om studiestedet som skal være samarbeidspart i avtalen. Velg avdelingen avtalen skal gjelde for.',
    en: 'Information regarding the faculty to be part of the agreement. Choose which faculty the agreement is to include',
  },
  studiestedSubtitleView: {
    id: `${namespace}.studiestedSubtitleView`,
    nb: 'Opplysninger om studiestedet som skal være samarbeidspart i avtalen.',
    en: 'Information regarding the faculty to be part of the agreement.',
  },
  praksissteder: {
    id: `${namespace}.praksissteder`,
    nb: 'Praksissteder',
    en: 'Practice places',
  },
  praksisstederSubtitle: {
    id: `${namespace}.praksisstederSubtitle`,
    nb: 'Fyll inn opplysninger om praksisstedene som skal inngå i avtalen.',
    en: 'Fill inn information regarding the practice places that are part of the agreement.',
  },
  praksisstederSubtitleView: {
    id: `${namespace}.praksisstederSubtitleView`,
    nb: 'Opplysninger om praksisstedene som skal inngå i avtalen.',
    en: 'Information regarding the practice places that are part of the agreement.',
  },
  praksistype: {
    id: `${namespace}.praksistype`,
    nb: 'Praksistype',
    en: 'Practice type',
  },
  praksistypeSubtitle: {
    id: `${namespace}.praksistypeSubtitle`,
    nb: 'Velg hvilke praksistyper denne samarbeidsavtalen omfatter. Det er mulig å legge til flere praksistyper. Du må velge minst én.',
    en: "Choose which practice types this agreement includes. It's possible to include multiple practice types. You must include at least one.",
  },
  praksistypeSubtitleView: {
    id: `${namespace}.praksistypeSubtitleView`,
    nb: 'Praksistypene denne samarbeidsavtalen omfatter. Det er mulig å ha flere praksistyper.',
    en: "The practice types this agreement includes. It's possible to include multiple practice types.",
  },
  avtaleinnhold: {
    id: `${namespace}.avtaleinnhold`,
    nb: 'Avtalens innhold',
    en: 'The contents of the agreement',
  },
  avtaleinnholdSubtitle: {
    id: `${namespace}.avtaleinnholdSubtitle`,
    nb: 'Last opp vedlegg for samarbeidsavtalen i PDF-format. Man kan laste opp ett dokument for selve samarbeidsavtalen, ett dokument for databehandleravtalen og et valgfritt antall andre vedlegg.',
    en: 'Upload attachments for the collaboration agreement in PDF format. You may upload one document for the collaboration agreement, one document for the data processing agreement, and a optional number of other attachments.',
  },
  avtaleinnholdSubtitleView: {
    id: `${namespace}.avtaleinnholdSubtitleView`,
    nb: 'Vedlegg som hører til samarbeidsavtalen i PDF-format. Det kan finnes ett dokument for selve samarbeidsavtalen, ett dokument for databehandleravtalen og et valgfritt antall andre vedlegg.',
    en: 'Attachments for the collaboration agreement in PDF format. It can exist one document for the collaboration agreement, one document for the data processing agreement, and a optional number of other attachments.',
  },
  tillatelser: {
    id: `${namespace}.tillatelser`,
    nb: 'Tillatelser og rettigheter',
    en: 'Permissions and rights',
  },
  signering: {
    id: `${namespace}.signering`,
    nb: 'Signering',
    en: 'Signing',
  },
  signeringSubtitle: {
    id: `${namespace}.signeringSubtitle`,
    nb: 'Her ser du listen over alle parter som skal signere denne samarbeidsavtalen. Avtalen signeres via. postens signeringsløsning.',
    en: 'This is a list of all parties that are to sign this agreement. The agreement is signed using Posten.',
  },
  fantValideringsfeilTitle: {
    id: `${namespace}.fantValideringsfeilTitle`,
    nb: 'Valideringsfeil funnet i FS',
    en: 'Validation errors found in FS',
  },
  lagreUtkast: {
    id: `${namespace}.lagreUtkast`,
    nb: 'Lagre',
    en: 'Save',
  },
  statusIkkeAktiv: {
    id: `${namespace}.statusIkkeAktiv`,
    nb: 'Ikke aktiv',
    en: 'Not active',
  },
  statusAktiv: {
    id: `${namespace}.statusAktiv`,
    nb: 'Aktiv',
    en: 'Active',
  },
  statusSendtTilSignering: {
    id: `${namespace}.statusSendtTilSignering`,
    nb: 'Sendt til signering',
    en: 'Waiting for signing',
  },
  statusInnhenterOpplysninger: {
    id: `${namespace}.statusInnhenterOpplysninger`,
    nb: 'Innhenter opplysninger',
    en: 'Gathering information',
  },
  statusKansellert: {
    id: `${namespace}.statusKansellert`,
    nb: 'Kansellert',
    en: 'Cancelled',
  },
  statusAvsluttet: {
    id: `${namespace}.statusAvsluttet`,
    nb: 'Avsluttet',
    en: 'Concluded',
  },
  statusUtkast: {
    id: `${namespace}.statusUtkast`,
    nb: 'Utkast',
    en: 'Draft',
  },
  statusFeil: {
    id: `${namespace}.statusFeil`,
    nb: 'Feil',
    en: 'Failed',
  },
  continue: {
    id: `${namespace}.continue`,
    nb: 'Fortsett',
    en: 'Continue',
  },
  avtaleAktiviteterWarningModalTitle: {
    id: `${namespace}.avtaleAktiviteterWarningModalTitle`,
    nb: 'Det finnes aktiviteter knyttet til avtalen som kan bli påvirket av endringene',
    en: 'There are activities connected to the agreement that could be influenced by the changes',
  },
  avtaleAktiviteterWarningModalSubtitle: {
    id: `${namespace}.avtaleAktiviteterWarningModalSubtitle`,
    nb: 'Vennligst se igjennom aktivitetene og gjør endringer der det er nødvendig.',
    en: 'Please look through the activites and make changes where it is necessary.',
  },
  aktiviteterHeaderPeriod: {
    id: `${namespace}.aktiviteterHeaderPeriod`,
    nb: 'Periode',
    en: 'Period',
  },
  aktiviteterHeaderEmnenavn: {
    id: `${namespace}.aktiviteterHeaderEmnenavn`,
    nb: 'Emnenavn',
    en: 'Subject name',
  },
  aktiviteterHeaderEmnebeskrivelse: {
    id: `${namespace}.aktiviteterHeaderEmnebeskrivelse`,
    nb: 'Emnebeskrivelse',
    en: 'Subject description',
  },
  aktiviteterHeaderPraksistype: {
    id: `${namespace}.aktiviteterHeaderPraksistype`,
    nb: 'Praksistype',
    en: 'Practice type',
  },
  aktiviteterHeaderPraksisklasse: {
    id: `${namespace}.aktiviteterHeaderPraksisklasse`,
    nb: 'Praksisklasse',
    en: 'Practice class',
  },
  aktiviteterHeaderBestiller: {
    id: `${namespace}.aktiviteterHeaderBestiller`,
    nb: 'Bestiller',
    en: 'Place of order',
  },
  aktiviteterHeaderHandling: {
    id: `${namespace}.aktiviteterHeaderHandling`,
    nb: 'Handling',
    en: 'Action',
  },
  aktiviteterVisAktivitet: {
    id: `${namespace}.aktiviteterVisAktivitet`,
    nb: 'Åpne aktiviteten i et nytt vindu',
    en: 'Open the activity in a new window',
  },
};

export default translations;
